import React, { useEffect, useMemo, useState } from "react";
import { Alert, Button, DatePicker, Modal, Select, Space, Table } from "antd";
import usePaginatedLogList from "../hooks/usePaginatedLogList";
import { dailyAuditChanges, dailyAuditColumns } from "../utils/dailyAuditChanges";
import { formatDateTime } from "../utils/dateFormatter";

export const auditAction = (value) => ({ 0: "Create", 1: "Update", 2: "Delete", 3: "Access" }[Number(value)] || "Unknown");

export default function AuditTrail({ endpoint, partField, part, title = "Audit Trail", showSubject = false }) {
  const [action, setAction] = useState();
  const [dates, setDates] = useState(null);
  const [selected, setSelected] = useState(null);
  const { data, loading, error, retry, load, pagination } = usePaginatedLogList(endpoint, "audit_logs");
  const params = useMemo(() => ({
    ...(partField ? { [partField]: part } : {}),
    ...(action !== undefined ? { action_type: action } : {}),
    ...(dates?.[0] ? { start_date: dates[0].format("YYYY-MM-DD") } : {}),
    ...(dates?.[1] ? { end_date: dates[1].format("YYYY-MM-DD") } : {}),
  }), [partField, part, action, dates]);
  useEffect(() => { load(params); }, [load, params]);
  const columns = [
    { title: "Record ID", dataIndex: "object_id", key: "object_id" },
    { title: "Record Type", dataIndex: "object_type", key: "object_type" },
    ...(showSubject ? [{ title: "Staff Member", dataIndex: "subject_name", key: "subject_name" }] : []),
    { title: "Action", dataIndex: "action", key: "action", render: auditAction },
    { title: "Vessel", dataIndex: "vessel_name", key: "vessel_name" },
    { title: "Performed By", dataIndex: "actor_name", key: "actor_name", render: value => value || "Not recorded" },
    { title: "Date & Time", dataIndex: "timestamp", key: "timestamp", render: formatDateTime },
    { title: "Changes", key: "changes", render: (_, record) => <Button onClick={() => setSelected(record)}>View changes</Button> },
  ];
  return <section>
    <h1 style={{marginBottom: 16}}>{title}</h1>
    <Space wrap style={{ marginBottom: 16 }}>
      <Select aria-label="Audit action" placeholder="All actions" allowClear value={action} onChange={setAction}
        style={{ width: 160 }} options={[0, 1, 2, 3].map(value => ({ value, label: auditAction(value) }))} />
      <DatePicker.RangePicker aria-label="Audit date range" value={dates} onChange={setDates} />
    </Space>
    {error && <Alert type="error" showIcon message={error} action={<Button onClick={retry}>Retry</Button>} />}
    <Table className="custom-table" bordered columns={columns} dataSource={data} pagination={pagination} rowKey="id" loading={loading} scroll={{ x: true }} />
    <Modal title="Change History" open={!!selected} onCancel={() => setSelected(null)} footer={<Button onClick={() => setSelected(null)}>Close</Button>} width="80%">
      <Table columns={dailyAuditColumns} dataSource={selected ? dailyAuditChanges(selected) : []} rowKey="field" pagination={false} scroll={{ x: true, y: 450 }} />
    </Modal>
  </section>;
}
